import React, { useEffect, useRef, useState } from "react";
import { Table, Tooltip, Col, Input, Row, Image } from "antd";
import HeadingBack from "./common/HeadingBack";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import SvgIcon from "./const/SvgIcon";
import { allApiAction } from "../Redux/common/action";

import { ExclamationCircleFilled } from "@ant-design/icons";
import { Modal } from "antd";
import { toast } from "react-toastify";
import { URL } from "../Redux/common/url";
import { AsyncPaginate } from "react-select-async-paginate";

import { CKEditor } from "ckeditor4-react";

const defaultObj = {
  city_id: "",
  name: "",
  description: "",
  image: "",
  pincode: "",
  lat: "",
  lang: "",
};

function Area() {
  const { confirm } = Modal;

  const fileInputRef = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const [areaDetails, setAreaDetails] = useState({ ...defaultObj });
  const [selectedFile, setSelectedFile] = useState(null);
  const [showDelelt, setShowDelete] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { areaList } = useSelector((state) => ({
    areaList: state?.allApi?.area_list || {},
  }));

  const listData = areaList?.data ? areaList?.data : [];

  useEffect(() => {
    // dispatch(allApiAction.getCities({ page: page, search: search }));
    dispatch(allApiAction.getAreas({ page: page, search: search }));
  }, [search, page]);

  const columns = [
    {
      width: "10%",
      key: "image",
      title: "Image",
      dataIndex: "image",
      render: (value, item, index) => {
        return (
          <>
            <div style={{ width: "50px" }}>
              <Image src={URL?.API_BASE_URL + item?.image}
                alt="N/A" />
            </div>
          </>
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "city",
      dataIndex: "city",
      key: "city",
      render: (value) => value?.name
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text) => {
        return (
          <div
            dangerouslySetInnerHTML={{ __html: text }}
            style={{ wordBreak: "break-word" }}
          />
        );
      },
    },
    {
      title: "lat",
      dataIndex: "lat",
      key: "lat",
    },
    {
      title: "lang",
      dataIndex: "lang",
      key: "lang",
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <Tooltip title="Edit">
              <span
                className="cursor-pointer"
                onClick={() => {
                  handleModal({
                    ...item, city_id: { value: item?.city?.id, label: item?.city?.name }
                  });
                }}
              >
                <SvgIcon.Edit className="scale-icon edit-icon" />
              </span>
            </Tooltip>
            <Tooltip title="Delete">
              <span
                className="cursor-pointer"
                onClick={() => {
                  showDeleteConfirm(item?.id);
                }}
              >
                <SvgIcon.deletebtn className="scale-icon edit-icon" />
              </span>
            </Tooltip>
          </>
        );
      },
    },
  ];

  const handleDelete = async (e) => {
    setShowDelete(false);
    await dispatch(allApiAction.deleteArea({ id: e, page: page }));
    await dispatch(allApiAction.getAreas({ page }));
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const files = event.target.files;
      setSelectedFile(files);
    }
  };

  const handleTextChange = (e) => {
    const { name, value } = e.target;
    setAreaDetails((prev) => ({ ...prev, [name]: value }));
  };

  const showDeleteConfirm = (e) => {
    confirm({
      title: "Are you sure delete ?",
      icon: <ExclamationCircleFilled />,
      content: "Area",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        handleDelete(e);
      },
      onCancel() {
      },
    });
  };

  const handleModal = (editData) => {
    editData && editData !== undefined ? setAreaDetails(editData) : setAreaDetails({});
    setIsModalOpen(!isModalOpen);
  };

  const handleSearch = (e) => {
    setSearch(e);
  };

  const handlePageChange = (currentPage) => {
    setPage(currentPage);
  };

  const loadOptions = async (apiUrl, search, currOptions, { page }) => {
    const token = await localStorage.getItem("admin_token");
    const url = `${URL.API_BASE_URL}${apiUrl}?page=${page}&search=${search}`;
    const response = await fetch(url,
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );
    const resJSON = await response.json();
    const res = resJSON?.data?.data;
    const options = res?.map((data) => ({ value: data?.id, label: data?.name }));

    const obj = {
      options: options,
      hasMore: resJSON?.data?.total > resJSON?.data?.to ? true : false,
      additional: {
        page: page + 1,
      },
    };
    return obj;
  };

  const checkValidation = () => {
    if (!areaDetails?.city_id) {
      toast.error("Please select city first");
      return false;
    } else if (!areaDetails?.name) {
      toast.error("Please enter a name");
      return false;
    } else if (!areaDetails?.pincode) {
      toast.error("Please enter a pincode");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {

    if (!checkValidation()) {
      return;
    }

    const data = new FormData();
    data.append("name", areaDetails?.name);
    data.append("city_id", areaDetails?.city_id?.value);
    data.append("pincode", areaDetails?.pincode);

    ["description", "lat", "lang",].map((key) => {
      if (areaDetails?.[key]) {
        data.append(key, areaDetails?.[key]);
      };
    });

    if (selectedFile) {
      for (let i = 0; i < selectedFile?.length; i++) {
        data.append("image", selectedFile[i]);
      }
    };
    try {
      if (areaDetails?.id) {
        data.append("id", areaDetails?.id);
        await dispatch(allApiAction.updateArea(data));
      } else {
        await dispatch(allApiAction.addArea(data));
        setSelectedFile(null);
      };
      dispatch(allApiAction.getAreas({ page: 1 }));

      handleModal();
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
        setSelectedFile(null);
      };
    } catch (error) {
      console.error("Error during API call:", error)
    };
  };

  return (
    <div>

      {/* Header Bar */}
      <div className="flex" >
        <div>
          <HeadingBack
            title={"Area"}
            subHeading={`Total ${areaList?.total || 0} Area`}
          />
        </div>
        <Col md={5} sm={5} xs={12} className="ml-5 pl-5">
          <Input
            type="text"
            autoComplete="new-off"
            className="form-control"
            onChange={(e) => handleSearch(e.target.value)}
            placeholder="Search..."
            value={search}
          />
        </Col>
        <div className="flex flex1 align-items-center justify-content-end">
          <Tooltip title="Add">
            <span className="jop_btn" onClick={() => handleModal()}>
              Add
              <SvgIcon.Add width={40} height={40} className="cursor-pointer" />
            </span>
          </Tooltip>
        </div>
      </div>

      {/* Form Modal */}
      <Modal
        key={isModalOpen ? "Modal Open" : "Modal Close"}
        title="Area Modal"
        open={isModalOpen}
        onOk={handleSubmit}
        onCancel={() => setIsModalOpen(false)}
      >
        <Row gutter={[20, 20]} >

          <Col lg={12} md={12} sm={12} xs={12} >
            <label className="mb-2">Select City : </label>
            <AsyncPaginate
              // key={managerKeyJen}
              additional={{ page: 1 }}
              value={areaDetails?.city_id}
              loadOptions={(search, loaded, obj) => loadOptions(URL.get_cities, search, loaded, obj)}
              onChange={(value) => {
                handleTextChange({ target: { name: "city_id", value: value } })
              }}
            />
          </Col>
          <Col lg={12} md={12} sm={12} xs={12} >
            <label className="mb-2">Name : </label>
            <input
              autoComplete="off"
              className="form-control"
              placeholder="Enter Name"
              name="name"
              value={areaDetails?.name}
              onChange={handleTextChange}
            />
          </Col>
          <Col lg={12} md={12} sm={12} xs={12} >
            <label className="mb-2">Image : </label>
            <input
              type="file"
              // multiple
              accept="image/*"
              onChange={handleFileChange}
            />
          </Col>

          <Col lg={12} md={12} sm={12} xs={12}>
            <label className="mb-2">Pincode : </label>
            <input
              autoComplete="off"
              className="form-control"
              placeholder="Enter Pincode"
              name="pincode"
              value={areaDetails?.pincode}
              onChange={(e) => {
                const value = e.target.value;
                if (/^-?\d*\.?\d*$/.test(value)) {
                  handleTextChange({ target: { name: "pincode", value } });
                }
              }} />
          </Col>

          <Col lg={24} md={24} sm={24} xs={24} className="mt-10">
            <div className="mb-4">
              <label className="form-label">Description</label>
              <div className="quill-container" style={{ marginBottom: '50px' }}>
             
                <CKEditor
                  initData={areaDetails?.description}
                  config={{
                    extraPlugins: 'table',
                    removePlugins: 'elementspath',
                    resize_enabled: false,
                    toolbarGroups: [
                      { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
                      { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align'] },
                      { name: 'insert' },
                      { name: 'styles' },
                      { name: 'colors' },
                      { name: 'links' },
                      { name: 'table' }
                    ],
                    // Optional: Configure table plugin defaults or allowed features
                    table_removeTableTag: false
                  }}
                  onChange={(event) => {
                    const data = event.editor.getData();
                    setAreaDetails((prev) => ({ ...prev, description: data }));
                  }}
                />
              </div>
            </div>
          </Col>

          <Col lg={12} md={12} sm={12} xs={12} >
            <label className="mb-2">Lat : </label>
            <input
              autoComplete="off"
              className="form-control"
              placeholder="lat"
              value={areaDetails?.lat}
              onChange={(e) => {
                const value = e.target.value;
                if (/^-?\d*\.?\d*$/.test(value)) {
                  handleTextChange({ target: { name: "lat", value } });
                }
              }}
            />
          </Col>
          <Col lg={12} md={12} sm={12} xs={12} >
            <label className="mb-2">Lang : </label>
            <input
              autoComplete="off"
              className="form-control"
              placeholder="lang"
              value={areaDetails?.lang}
              onChange={(e) => {
                const value = e.target.value;
                if (/^-?\d*\.?\d*$/.test(value)) {
                  handleTextChange({ target: { name: "lang", value } });
                }
              }}
            />
          </Col>
        </Row>
      </Modal>


      {/* Pagination Table */}
      <div className="tableResponsive mt-10">
        <Table
          dataSource={listData}
          columns={columns}
          className={"table antd_table"}
          pagination={{
            current: page,
            pageSize: 10,
            onChange(currentPage, pageSize) {
              handlePageChange(currentPage);
            },
            hideOnSinglePage: true,
            total: areaList?.total ? areaList?.total : 0,
          }}
        />
      </div>
    </div>
  );
}

export default Area;
